import React, { useEffect, useState } from 'react';
import { 
  subscribeToConversations, 
  markMessagesAsRead 
} from '../services/messageService';
import '../styles/MessagesList.css';
import ErrorNotification from './ErrorNotification';

const MessagesList = ({ walletAddress, onClose, onChatOpen }) => {
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    let unsubscribe = null;

    const initializeConversations = async () => {
      setLoading(true);
      try {
        // Subscribe to conversations
        unsubscribe = subscribeToConversations(walletAddress, (data) => {
          setConversations(data);
          setLoading(false);
          setError('');
        });
      } catch (error) {
        if (unsubscribe) {
          unsubscribe();
        }
        setError(error.message || 'Failed to load conversations');
        setErrorMessage(error.message || 'Failed to load conversations');
        setLoading(false);
      }
    };

    initializeConversations();

    // Cleanup on unmount
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [walletAddress]);

  const handleOpenChat = (friend) => {
    // Mark messages as read when opening chat
    if (friend && friend.walletAddress) {
      markMessagesAsRead(walletAddress, friend.walletAddress)
        .catch(error => {
          console.error("Error marking messages as read:", error);
        });
    }
    onChatOpen(friend);
  };

  const formatTime = (timestamp) => {
    return timestamp
      ? new Date(timestamp).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
      : 'Unknown Time';
  };

  return (
    <div className="messages-list-container">
      <div className="messages-list-header">
        <h2>Messages</h2>
        <button className="close-btn" onClick={onClose}>×</button>
      </div>

      {loading ? (
        <div className="loading-container">
          <div className="loading-indicator"></div>
          <p>Loading conversations...</p>
        </div>
      ) : error ? (
        <p className="error-message">{error}</p>
      ) : conversations.length === 0 ? (
        <p className="no-messages">No conversations yet</p>
      ) : (
        <ul className="conversations-list">
          {conversations.map((convo) => (
            <li
              key={convo.friend.walletAddress}
              className={`conversation-item ${convo.unreadCount > 0 ? 'unread' : ''}`}
              onClick={() => handleOpenChat(convo.friend)}
            >
              <div className="conversation-info">
                <span className="username">{convo.friend.username}</span>
                <span className="wallet">
                  {convo.friend.walletAddress.substring(0, 6)}...
                  {convo.friend.walletAddress.substring(convo.friend.walletAddress.length - 4)}
                </span>
                <span className="latest-message">{convo.lastMessage}</span>
              </div>
              <div className="conversation-meta">
                <span className="timestamp">{formatTime(convo.timestamp)}</span>
                {convo.unreadCount > 0 && <span className="unread-badge">{convo.unreadCount}</span>}
              </div>
            </li>
          ))}
        </ul>
      )}
      <ErrorNotification 
        message={errorMessage}
        onClose={() => setErrorMessage('')}
      />
    </div>
  );
};

export default MessagesList;